function formatPricePlan (num) {
    const n = Number(num)
    if (num === '' || num === undefined || num === null || Number.isNaN(n)) {
        return ''
    }
    return new Intl.NumberFormat('ru-RU').format(n) + '₽'
}

function hasMeaningfulLotPlotPrice (raw) {
    if (raw === null || raw === undefined || raw === '') {
        return false
    }
    const n = Number(raw)
    return !Number.isNaN(n) && n > 0
}

function hasMeaningfulBlagoPrice (raw) {
    if (raw === null || raw === undefined || raw === '') {
        return false
    }
    const n = Number(raw)
    if (!Number.isNaN(n)) {
        return n > 0
    }
    return String(raw).trim() !== ''
}

function setPlotPriceRowHidden (row, hidden) {
    if (!row) return
    if (hidden) {
        row.setAttribute('hidden', '')
        row.hidden = true
        row.style.setProperty('display', 'none', 'important')
    } else {
        row.removeAttribute('hidden')
        row.hidden = false
        row.style.removeProperty('display')
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const svg = document.getElementById('plan-svg')
    const planCards = Array.from(
        document.querySelectorAll('.service-card.plan-card, .service-card.plan-card2')
    )
    const planInfo1 = document.querySelector('.plan-info--1')
    const planInfo2 = document.querySelector('.plan-info--2')

    if (!svg || !planInfo1 || !planInfo2 || planCards.length === 0) {
        return
    }

    const modal = document.getElementById('vv-modal')
    const modalBox = modal?.querySelector('.vv-modal__box')

    let hideLotPopup = () => {}
    let showLotPopup = () => {}

    if (modal && modalBox) {
        let liveNode = null
        let livePH = null

        showLotPopup = function (cardEl, { clone = true } = {}) {
            if (!cardEl) return
            modalBox.innerHTML = ''
            liveNode = null
            livePH = null

            let node = cardEl
            if (clone) {
                node = cardEl.cloneNode(true)
            } else {
                liveNode = cardEl
                livePH = document.createElement('div')
                livePH.style.display = 'none'
                cardEl.parentNode &&
                    cardEl.parentNode.insertBefore(livePH, cardEl)
            }

            const scope = document.createElement('div')
            // Keep `.plan`-scoped styles working after moving the card into modal.
            scope.className = 'plan'
            scope.appendChild(node)
            modalBox.appendChild(scope)

            document.documentElement.style.overflow = 'hidden'
            modal.removeAttribute('hidden')
        }

        hideLotPopup = function () {
            modal.setAttribute('hidden', '')
            document.documentElement.style.overflow = ''
            if (liveNode) {
                setInstallmentBlockVisible(liveNode, true)
                liveNode.classList.remove(
                    'plan-card--active',
                    'plan-card2--active',
                    'no-lot-price'
                )
            }
            if (liveNode && livePH && livePH.parentNode) {
                livePH.parentNode.replaceChild(liveNode, livePH)
            }
            liveNode = null
            livePH = null
            modalBox.innerHTML = ''
        }

        modal.addEventListener('click', e => {
            if (e.target.closest('[data-close]')) hideLotPopup()
        })
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
                hideLotPopup()
            }
        })
    }

    function setText (container, selector, text) {
        if (!container) return
        const el = container.querySelector(selector)
        if (el) {
            el.textContent =
                text !== undefined && text !== null ? String(text) : ''
        }
    }

    function setImage (container, selector, imageUrl) {
        if (!container || !imageUrl) return
        const imgElement = container.querySelector(selector)
        if (imgElement) {
            imgElement.src = imageUrl
            imgElement.style.display = imageUrl ? 'block' : 'none'
        }
    }

    function setLotPreviewPicture (card, webpUrl, avifUrl) {
        const pic = card?.querySelector('.service-card__img picture')
        if (!pic) return
        const fbWebp = pic.dataset.fallbackWebp || ''
        const fbAvif = pic.dataset.fallbackAvif || ''
        const useWebp = webpUrl || fbWebp
        const useAvif = avifUrl || fbAvif
        const img = pic.querySelector('img.picture__bg')
        const avifSource = pic.querySelector('source[type="image/avif"]')
        const webpSource = pic.querySelector('source[type="image/webp"]')
        if (avifSource) {
            avifSource.srcset = useAvif
        }
        if (webpSource) {
            webpSource.srcset = useWebp
        }
        if (img) {
            img.src = useWebp
            img.style.display = 'block'
        }
    }

    function resetContractElem (card) {
        if (!card) return
        const contractElem = card.querySelector('.service-card__contract')
        if (contractElem) {
            contractElem.style.opacity = '0'
            contractElem.style.pointerEvents = 'none'
        }
    }

    function enableContractElem (card) {
        if (!card) return
        const contractElem = card.querySelector('.service-card__contract')
        if (contractElem) {
            contractElem.style.opacity = '1'
            contractElem.style.pointerEvents = 'auto'
        }
    }

    function hideItemNumber (card) {
        if (!card) return
        const itemNumberElement = card.querySelector('.item-number')
        if (itemNumberElement) {
            const serviceCardItem = itemNumberElement.closest('.service-card__item')
            if (serviceCardItem) {
                serviceCardItem.style.opacity = '0'
                serviceCardItem.style.pointerEvents = 'none'
                serviceCardItem.style.height = '0'
                serviceCardItem.style.overflow = 'hidden'
            }
        }
    }

    function showAllItems () {
        document.querySelectorAll('.service-card__item').forEach(item => {
            item.style.opacity = '1'
            item.style.pointerEvents = 'auto'
            item.style.height = ''
            item.style.overflow = ''
        })
    }

    function positionCardAdjacent (card, targetRect) {
        if (!card || !targetRect) return

        const prevVisibility = card.style.visibility
        const prevDisplay = card.style.display
        const prevPosition = card.style.position

        card.style.visibility = 'hidden'
        card.style.display = 'block'
        card.style.position = 'absolute'

        const cardRect = card.getBoundingClientRect()
        const cardHeight = cardRect.height
        const cardWidth = cardRect.width

        const viewportHeight = window.innerHeight
        const viewportWidth = window.innerWidth
        const scrollY =
            window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop

        const spaceAbove = targetRect.top
        const spaceBelow = viewportHeight - targetRect.bottom

        let topValue
        if (cardHeight <= spaceBelow) {
            topValue = scrollY + targetRect.bottom
        } else if (cardHeight <= spaceAbove) {
            topValue = scrollY + targetRect.top - cardHeight
        } else {
            const centered = Math.max(10, (viewportHeight - cardHeight) / 2)
            topValue = scrollY + centered
        }

        const gap = 10
        let leftValue = 0

        const tryRight = targetRect.right + gap
        const rightOverflow = tryRight + cardWidth - viewportWidth
        if (rightOverflow <= -10) {
            leftValue = tryRight
        } else {
            const tryLeft = targetRect.left - gap - cardWidth
            if (tryLeft >= 10) {
                leftValue = tryLeft
            } else {
                leftValue = Math.max(10, (viewportWidth - cardWidth) / 2)
            }
        }

        card.style.top = topValue + 'px'
        card.style.left = leftValue + 'px'

        card.style.visibility = prevVisibility || ''
        card.style.display = prevDisplay || ''
        card.style.position = prevPosition || 'absolute'
    }

    function setInstallmentBlockVisible (card, visible) {
        const wrap = card?.querySelector('.installment__link')
        if (!wrap) return
        if (visible) {
            wrap.removeAttribute('hidden')
            wrap.hidden = false
            wrap.style.removeProperty('display')
        } else {
            wrap.setAttribute('hidden', '')
            wrap.hidden = true
            wrap.style.setProperty('display', 'none', 'important')
        }
    }

    function resetOffersInstallmentLink (card) {
        const link = card?.querySelector('.installment__link a')
        const base = link?.dataset?.offersBase
        if (link && base) {
            link.href = base
        }
    }

    function setOffersInstallmentLink (card, lotNumber) {
        const link = card?.querySelector('.installment__link a')
        const base = link?.dataset?.offersBase
        if (!link || !base) return
        const id = lotNumber !== undefined && lotNumber !== null ? String(lotNumber).trim() : ''
        link.href = id ? `${base}?lot_number=${encodeURIComponent(id)}` : base
    }

    function closeAllPlanCards () {
        planCards.forEach(card => {
            card.classList.remove(
                'plan-card--active',
                'plan-card2--active',
                'no-lot-price'
            )
            resetContractElem(card)
            setLotPreviewPicture(card, '', '')
            resetOffersInstallmentLink(card)
            setInstallmentBlockVisible(card, true)
        })
        planInfo1.classList.remove('plan-info--active')
        planInfo2.classList.remove('plan-info--active')
        const plotPriceRowClosed = planInfo2.querySelector('.plan-info__item--plot-price')
        setPlotPriceRowHidden(plotPriceRowClosed, true)
        showAllItems()
        hideLotPopup()
    }

    function syncPlanInfoStrip (group) {
        const area = group.getAttribute('data-area')
        const area2 = group.getAttribute('data-area2') || ''
        const price = group.getAttribute('data-price') || ''
        const plotPrice = group.getAttribute('data-plot-price') || ''
        const imageUrl = group.getAttribute('data-image') || ''
        const imageAvif = group.getAttribute('data-image-avif') || ''
        const plotPriceRow = planInfo2.querySelector('.plan-info__item--plot-price')

        if (area) {
            setText(planInfo1, '.item-number', area)
            setText(planInfo1, '.item-number2', area2)
            setText(planInfo1, '.item-price', price)
            setImage(planInfo1, '.service-card__img img', imageUrl)
            setLotPreviewPicture(planInfo1, imageUrl, imageAvif)

            setPlotPriceRowHidden(plotPriceRow, true)

            planInfo1.classList.add('plan-info--active')
            planInfo2.classList.remove('plan-info--active')
        } else {
            setText(planInfo2, '.item-number', area || '')
            setText(planInfo2, '.item-number2', area2)
            let plotPriceText = ''
            if (hasMeaningfulLotPlotPrice(plotPrice)) {
                plotPriceText = formatPricePlan(plotPrice)
            } else if (String(price || '').trim() !== '') {
                plotPriceText = price
            }
            const showPlotPrice = plotPriceText !== ''
            const plotPriceSelector = plotPriceRow
                ? '.plan-info__item--plot-price .item-price'
                : '.item-price'
            setText(planInfo2, plotPriceSelector, plotPriceText)
            setPlotPriceRowHidden(plotPriceRow, !showPlotPrice)
            setImage(planInfo2, '.service-card__img img', imageUrl)
            setLotPreviewPicture(planInfo2, imageUrl, imageAvif)

            planInfo2.classList.add('plan-info--active')
            planInfo1.classList.remove('plan-info--active')
        }
    }

    svg.querySelectorAll('g g').forEach(group => {
        group.addEventListener('mouseenter', function () {
            const status = group.getAttribute('data-status')
            if (status === '2') {
                return
            }

            syncPlanInfoStrip(group)
        })

        group.addEventListener('mouseleave', function () {
            planInfo1.classList.remove('plan-info--active')
            planInfo2.classList.remove('plan-info--active')
            const plotPriceRow = planInfo2.querySelector('.plan-info__item--plot-price')
            setPlotPriceRowHidden(plotPriceRow, true)
        })

        group.addEventListener('click', function (event) {
            event.stopPropagation()

            const status = group.getAttribute('data-status')
            if (status === '2') {
                return
            }

            syncPlanInfoStrip(group)

            const area = group.getAttribute('data-area') || ''
            const area2 = group.getAttribute('data-area2') || ''
            const housePrice = group.getAttribute('data-house-price') || ''
            const blagoPrice = group.getAttribute('data-blago-price') || ''
            const plotPrice = group.getAttribute('data-plot-price') || ''
            const price = group.getAttribute('data-price') || ''
            const imageUrl = group.getAttribute('data-image') || ''
            const imageAvif = group.getAttribute('data-image-avif') || ''
            const rect = group.getBoundingClientRect()
            const id = group.getAttribute('id') || ''
            const withContractor = group.getAttribute('data-with-contractor')
            const projectUrl = group.getAttribute('data-project-url') || ''
            const dataInstallment = group.getAttribute('data-is-installment')
            const showInstallmentLink = dataInstallment !== '0'

            showAllItems()

            planCards.forEach(card => {
                card.classList.remove(
                    'plan-card--active',
                    'plan-card2--active',
                    'no-lot-price'
                )
                resetContractElem(card)
            })

            const isBuilding = status === '3'

            let cardToShow = null
            if (isBuilding) {
                cardToShow = document.querySelector('.service-card.plan-card')
                if (window.innerWidth <= 596) {
                    cardToShow?.classList.add('plan-card--active')
                    showLotPopup(cardToShow, { clone: false })
                } else if (cardToShow) {
                    cardToShow.classList.add('plan-card--active')
                }
            } else {
                cardToShow = document.querySelector('.service-card.plan-card2')
                if (window.innerWidth <= 596) {
                    cardToShow?.classList.add('plan-card2--active')
                    showLotPopup(cardToShow, { clone: false })
                } else if (cardToShow) {
                    cardToShow.classList.add('plan-card2--active')
                }
            }

            if (cardToShow) {
                setText(cardToShow, '.id-number', id)
                setInstallmentBlockVisible(cardToShow, showInstallmentLink)
                if (showInstallmentLink) {
                    setOffersInstallmentLink(cardToShow, id)
                } else {
                    resetOffersInstallmentLink(cardToShow)
                }
                setText(cardToShow, '.item-number', area)
                setText(cardToShow, '.item-number2', area2)
                setText(cardToShow, '.item-number3', formatPricePlan(housePrice))
                setText(cardToShow, '.item-number4', formatPricePlan(plotPrice))
                setText(cardToShow, '.item-numberb', formatPricePlan(blagoPrice))
                const blagoRow = cardToShow.querySelector('.blago-row')
                setPlotPriceRowHidden(blagoRow, !hasMeaningfulBlagoPrice(blagoPrice))
                if (isBuilding) {
                    setText(cardToShow, '.total-price', price)
                } else {
                    const priceSpan = cardToShow.querySelector(
                        '.service-card__price.item-price span'
                    )
                    if (priceSpan) {
                        priceSpan.textContent = price.replace(/₽/g, '').trim()
                    } else {
                        setText(cardToShow, '.item-price', price)
                    }
                }
                setLotPreviewPicture(cardToShow, imageUrl, imageAvif)

                if (window.innerWidth >= 596) {
                    positionCardAdjacent(cardToShow, rect)
                }

                if (window.innerWidth >= 596) {
                    cardToShow.style.position = 'absolute'
                }

                if (withContractor === '1') {
                    enableContractElem(cardToShow)
                } else {
                    resetContractElem(cardToShow)
                }

                if (!group.hasAttribute('data-area')) {
                    hideItemNumber(cardToShow)
                }

                if (!isBuilding && cardToShow.classList.contains('plan-card2')) {
                    if (hasMeaningfulLotPlotPrice(plotPrice)) {
                        cardToShow.classList.remove('no-lot-price')
                    } else {
                        cardToShow.classList.add('no-lot-price')
                    }
                }
            }
        })
    })

    planCards.forEach(card => {
        card.addEventListener('click', function (event) {
            if (event.target.closest('.service-card__close')) {
                return
            }
            event.stopPropagation()
        })
    })

    document.addEventListener('click', function (event) {
        const closeInCard = event.target.closest('.service-card__close')
        if (closeInCard) {
            if (closeInCard.closest('#vv-modal')) {
                hideLotPopup()
            } else {
                closeAllPlanCards()
            }
            return
        }

        if (!event.target.closest('.service-card')) {
            closeAllPlanCards()
        }
    })
})
